var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTeamImg1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 182,
  height: 182,
  viewBox: "0 0 182 182"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 91,
  r: 91,
  fill: "#7654fd",
  "data-name": "Ellipse 4"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#f0f0f0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "m112.248 103.384-2.55-3.826v-8.986c0-3.423-6.5-7.086-8.986-8.986",
  "data-name": "Path 265"
}), /*#__PURE__*/React.createElement("path", {
  d: "m104.015 92.786-6.244-5a2.231 2.231 0 0 0-3.155 3.155l6.047 6.825v4.279c0 2.022 2.889 5.212 2.889 5.212",
  "data-name": "Path 266"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.576 104.694H76.104a2.354 2.354 0 0 1-2.352-2.353V71.1a2.35 2.35 0 0 1 2.352-2.351h22.252a2.354 2.354 0 0 1 2.355 2.352V90.14",
  "data-name": "Path 267"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.157 73.884h5.135v5.135",
  "data-name": "Path 268"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.292 73.884 78.887 88.005",
  "data-name": "Path 269"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.438 94.423v5.135",
  "data-name": "Path 270"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.573 90.572v8.986",
  "data-name": "Path 271"
}))));
export default SvgTeamImg1;